import { render, staticRenderFns } from "./OnDemand.vue?vue&type=template&id=e1489f5c&scoped=true&"
import script from "./OnDemand.vue?vue&type=script&lang=js&"
export * from "./OnDemand.vue?vue&type=script&lang=js&"
import style0 from "./OnDemand.vue?vue&type=style&index=0&id=e1489f5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1489f5c",
  null
  
)

export default component.exports